import React, { useState, useEffect, useContext } from "react";
import {
	Paper,
	Grid,
	TextField,
	Button,
	Snackbar,
	Alert,
	CircularProgress,
	Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SiteContext, saveUser } from "gatsby-frontend";

export default function ProfileForm() {
	const theme = useTheme();
	const { dispatch, userData } = useContext(SiteContext);

	const [userFormValues, setUserFormValues] = useState({});
	const [submitting, setSubmitting] = useState(false);
	const [snackMessage, setSnackMessage] = useState({ open: false });

	useEffect(() => {
		if (userData) setUserFormValues(userData.attributes);
	}, [userData]);

	const subumitUpdate = async (e) => {
		setSubmitting(true);
		e.preventDefault();

		let response = await saveUser(dispatch, {
			...userData,
			attributes: { ...userFormValues },
		});

		if (response != false) {
			setSnackMessage({
				open: true,
				severity: "success",
				message: "Profile updated successfully!",
			});
		} else {
			setSnackMessage({
				open: true,
				severity: "error",
				message: "There was an error updating your profile",
			});
		}

		setSubmitting(false);
	};

	const onFormInputChange = (e) => {
		e.preventDefault();
		userFormValues[e.target.name] = e.target.value;
		setUserFormValues({ ...userFormValues });
	};

	const handleSnackClose = () => {
		setSnackMessage({
			...snackMessage,
			open: false,
		});
	};

	return (
		<>
			<Paper
				onSubmit={subumitUpdate}
				elevation={3}
				sx={{
					padding: theme.spacing(3, 2),
				}}
				component="form"
			>
				<Typography
					variant="h4"
					sx={(theme) => ({ marginBottom: theme.spacing(2) })}
				>
					Edit Profile
				</Typography>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TextField
							disabled={submitting}
							label="First Name"
							fullWidth
							variant="outlined"
							name="field_first_name"
							value={userFormValues["field_first_name"] || ""}
							onChange={onFormInputChange}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField
							disabled={submitting}
							label="Last name"
							fullWidth
							variant="outlined"
							name="field_last_name"
							value={userFormValues["field_last_name"] || ""}
							onChange={onFormInputChange}
						/>
					</Grid>
					<Grid item xs={12}>
						<Button
							disabled={submitting}
							type="submit"
							fullWidth
							variant="contained"
						>
							{!submitting ? "Update profile" : <CircularProgress size={20} />}
						</Button>
					</Grid>
				</Grid>
			</Paper>
			<Snackbar
				open={snackMessage.open}
				autoHideDuration={6000}
				onClose={handleSnackClose}
			>
				<Alert
					onClose={handleSnackClose}
					severity={snackMessage.severity || "success"}
					sx={{ width: "100%" }}
				>
					{snackMessage.message}
				</Alert>
			</Snackbar>
		</>
	);
}
